<div class="content">
  <div class="content-panel">
    <!-- Button open column modal -->
    @if (historique.length > 0) {
      <div class="d-flex justify-content-end mb-2 mr-2">
        <button class="btn btn-outline-primary d-flex align-items-center" (click)="openColumnModal()">
          <fa-icon icon="columns"></fa-icon>
          <span class="px-2">Colonnes</span>
          <span class="badge bg-primary text-white ms-2">{{ getVisibleColumnCount() }} / {{ columns.length }}</span>
        </button>
      </div>
    }

    <!--- Tableau --->
    @if (historique.length > 0) {
      <p-table
        #dt
        [value]="historique"
        [paginator]="true"
        [rows]="30"
        [scrollable]="true"
        scrollHeight="calc(100vh - 250px)">

        <ng-template pTemplate="header">
          <tr>
            @for (col of columns; track col) {
              @if (col.visible) {
                <th
                  scope="col"
                  [pSortableColumn]="col.field"
                  [style.min-width]="col.width"
                  pFrozenColumn
                  [frozen]="col.frozen">
                  {{ col.label | translate }}
                  <p-sortIcon [field]="col.field" />
                  @if (col.filter === 'modificationType' && typeModifications.length > 1) {
                    <p-columnFilter field="{{ col.field }}" matchMode="in" display="menu" [showOperator]="false" [showMatchModes]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiselect [options]="typeModifications"
                                       (onChange)="filter($event.value)"
                                       [ngModel]="value"
                                       [filter]="false"
                                       placeholder="Sélectionner un type de modification"
                                       optionLabel="name"
                                       optionValue="name"
                                       display="chip">
                        </p-multiselect>
                      </ng-template>
                    </p-columnFilter>
                  } @else {
                    <p-columnFilter type="{{ col.filter }}" field="{{ col.field }}" display="menu" [showOperator]="false" />
                  }
                </th>
              }
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-historique>
          <tr>
            @for (col of columns; track col) {
              @if (col.visible) {
                <td
                  [style.min-width]="col.width"
                  pFrozenColumn
                  [frozen]="col.frozen">
                  {{ getCellValue(historique, col.field) }}
                </td>
              }
            }
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
</div>

<!-- Modal paramétage des colonnes -->
<ng-template #columnModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Sélection des colonnes</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    @for (col of columns; track $index) {
      <div class="form-check">
        <input class="form-check-input" type="checkbox" [checked]="col.visible" (change)="toggleColumnVisibility(col.field)" id="{{col.field}}">
        <label class="form-check-label" [for]="col.field" translate>
          {{ col.label }}
        </label>
      </div>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Fermer</button>
  </div>
</ng-template>
